<template>
    <form
        class="flex flex-col gap-4"
        @submit="onSubmit"
    >
        <LockedEditingBanner v-if="sessionStore.isLocked" />
        <fieldset
            :disabled="sessionStore.isLocked"
            :inert="sessionStore.isLocked || undefined"
            class="min-w-0"
            :class="{ 'cursor-not-allowed opacity-50': sessionStore.isLocked }"
        >
            <MuvalPickupDate :form="form" />
        </fieldset>
        <div class="ml-auto flex gap-4">
            <MuvalButton
                borderless
                tertiary
                @click.prevent="closeDateDialog"
            >
                Cancel
            </MuvalButton>
            <MuvalButton
                type="submit"
                primary
                alternate
                :disabled="isLoading || sessionStore.isLocked"
                :loading="isLoading"
            >
                Save new dates
            </MuvalButton>
        </div>
    </form>
</template>

<script setup>
import { useForm } from 'vee-validate';
import { useResultsStore, useSessionStore } from '@/store';
import { closeDateDialog } from '@/composables/dialog';

const sessionStore = useSessionStore();
const initialValues = ref({
    move: {
        pickup_date_from: sessionStore.getPrimaryProduct.pickup_date_from,
        pickup_date_by: sessionStore.getPrimaryProduct.pickup_date_by,
        pickup_date_interval: sessionStore.getPrimaryProduct.pickup_date_interval,
        pickup_date_type: sessionStore.getPrimaryProduct.pickup_date_type,
        pickup_date_flexibility: sessionStore.getPrimaryProduct.pickup_date_flexibility,
    },
});

const form = useForm({
    initialValues: initialValues.value,
});

const router = useRouter();
const isLoading = ref(false);
const onSubmit = form.handleSubmit(async (values) => {
    isLoading.value = true;
    await window.axios.patch(`/customers/book/move/${sessionStore.getMoveId}/pickup/date`, {
        ...values,
    });

    await sessionStore.retrieve();

    const results = useResultsStore();
    if (sessionStore.isLocal) {
        results.startRange = null;
        results.endRange = null;
        results.direction = null;
        await results.refetchPricing();
    } else {
        // fetch matches
        await results.prefetch();
    }

    if (sessionStore.hasReachedResults) {
        router.replace({ name: 'Loading' });
    }

    closeDateDialog();
    isLoading.value = false;
});
</script>
